import { render } from "./DeleteUnitModal.vue?vue&type=template&id=5557e054"
import script from "./DeleteUnitModal.vue?vue&type=script&lang=js"
export * from "./DeleteUnitModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__